import { useMemo, type ReactNode } from 'react';
import { RelayEnvironmentProvider } from 'react-relay';
import { useAuth } from '@/lib/auth/AuthContext';
import { createRelayEnvironment } from '@/lib/RelayEnvironment';

interface RelayProviderProps {
  children: ReactNode;
}

/**
 * Provider that creates a Relay environment with the current auth token.
 * Re-creates the environment when the access token changes.
 */
export function RelayProvider({ children }: RelayProviderProps) {
  const { accessToken } = useAuth();

  const environment = useMemo(() => {
    return createRelayEnvironment(() => accessToken);
  }, [accessToken]);

  return (
    <RelayEnvironmentProvider environment={environment}>
      {children}
    </RelayEnvironmentProvider>
  );
}
